import { useMemo } from 'react';
import { AuditAction } from '@dealstack/shared/lib/generated';
import { BasicMantineTable } from '@dealstack/frontend/shared/components/BasicMantineTable/BasicMantineTable.tsx';
import { getAuditListColumns } from '@dealstack/frontend/shared/components/Audit/AuditLayout/auditTableColumns.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TransformedAuditData } from '@dealstack/frontend/shared/components/Audit/types.ts';

interface Props {
	changes: TransformedAuditData[];
	auditAction: AuditAction;
	dataTestId: string;
}

export const DealEventChangesTable = ({ changes, auditAction, dataTestId }: Props) => {
	const tCapManage = useTranslationCapManage();

	const columns = useMemo(
		() => getAuditListColumns({ tCapManage, auditAction }),
		[auditAction, tCapManage]
	);

	return (
		<BasicMantineTable
			columns={columns}
			data={changes}
			hideTopToolbar
			enableVerticalCellBorders
			dataTestId={dataTestId}
		/>
	);
};
